import type { ReactNode } from 'react';

export interface PageHeaderProps {
    title: ReactNode;
    description?: ReactNode;
    actions?: ReactNode;
    children?: ReactNode;
}

/** Cabeçalho de tela: título, apoio e as ações do módulo. */
export function PageHeader({ title, description, actions, children }: PageHeaderProps) {
    return (
        <header style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 20, flexWrap: 'wrap' }}>
                <div>
                    <h1 style={{ margin: 0, fontFamily: 'var(--font-ui)', fontSize: 22, lineHeight: '30px', fontWeight: 600, letterSpacing: '-0.02em', color: 'var(--text-primary)' }}>{title}</h1>
                    {description && <p style={{ margin: '4px 0 0', fontSize: 13.5, lineHeight: '20px', color: 'var(--text-secondary)' }}>{description}</p>}
                </div>
                {actions && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>{actions}</div>}
            </div>
            {children}
        </header>
    );
}
